import ArticlesView from '../views/ArticlesView';

const ArticlesContainer = () => {
  return (
    <ArticlesView />
  );
};

export default ArticlesContainer;
